import clsx from 'clsx';

interface IProps {
  tabs: { value: string; label: string }[];
  handleTabChange: (tab: { value: string; label: string }) => void;
  activeTab: string;
  tabId: string;
  wrapperClass?: string;
  tabsListClassName?: string;
  tabClassName?: string;
}

export const DefaultTabs = ({
  tabs,
  handleTabChange,
  activeTab,
  tabId,
  wrapperClass,
  tabsListClassName,
  tabClassName,
}: IProps) => {
  return (
    <div
      data-testid={tabId}
      id={tabId}
      className={clsx('w-full border-b-[1px] border-grey-1 flex scroll-mt-[96px]', {
        [`${wrapperClass}`]: wrapperClass,
      })}
    >
      <ul
        className={clsx('w-full flex gap-base text-black-6 text-base leading-[25.6px] relative top-[1px]', {
          [`${tabsListClassName}`]: tabsListClassName,
        })}
      >
        {tabs.map((tab, index) => (
          <li
            data-testid={`${tabId}-default`}
            key={index}
            onClick={() => {
              handleTabChange(tab);
            }}
            className={clsx(
              `
              whitespace-normal [@media(min-width:400px)]:whitespace-nowrap
              py-[10px] px-[2px] select-none
              border-b-[2px] cursor-pointer
              hover:border-purple-8 duration-300
              ${activeTab === tab.value ? 'text-purple-9 border-purple-8' : 'text-black-6 border-transparent'}
            `,
              {
                [`${tabClassName}`]: tabClassName,
              },
            )}
          >
            <span>{tab.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
